/*
  Eyeshells: Mobile PDP swatch long-press preview
  - Hold on a swatch image to show a temporary “bubble zoom” preview
  - Release to dismiss
  - Does NOT interfere with normal tap-to-select
*/
(function(){
  'use strict';

  function isMobile(){
    return window.matchMedia && window.matchMedia('(max-width: 767.98px)').matches;
  }

  // Only on product template (PDP)
  function isPDP(){
    // Theme doesn't always set template-product on <body>.
    // Use URL + DOM presence to detect PDP reliably.
    try{
      if (window.location && /\/products\//.test(window.location.pathname || '')) return true;
    }catch(e){}
    // Fallback: look for the swatch strip / product form
    return !!(document.querySelector && (document.querySelector('.es-swatch-strip') || document.querySelector('form[action^="/cart/add"]') || document.querySelector('form[action="/cart/add"]')));
  }

  // Swatch "press area" (covers image + text zone)
  // We listen on the whole swatch item so holding the color name (Black/Green/White)
  // triggers the same preview as holding the swatch image.
  var SWATCH_PRESS_SELECTOR = [
    '.es-swatch-strip .maxus-color',
    '.swatch_gallery .maxus-color'
  ].join(',');

  // Inside each swatch item, these elements carry the background-image we want to zoom.
  var SWATCH_LABEL_IN_ITEM = [
    'label.color_style2',
    'label.bg_image',
    'label.link_color',
    'label.color_style1'
  ].join(',');

  // Backwards compatible: actual label elements (used by elementFromPoint scrubbing)
  var SWATCH_IMG_SELECTOR = [
    '.es-swatch-strip label.color_style2',
    '.es-swatch-strip label.bg_image',
    '.es-swatch-strip label.link_color',
    '.es-swatch-strip label.color_style1',
    '.swatch_gallery label.color_style2',
    '.swatch_gallery label.bg_image',
    '.swatch_gallery label.link_color',
    '.swatch_gallery label.color_style1'
  ].join(',');

  var pressTimer = null;
  var pressTarget = null;
  var startX = 0;
  var startY = 0;
  var previewShown = false;
  // When true, we've entered long-press preview mode. Used to suppress
  // the synthetic click some browsers fire on touchend.
  var previewMode = false;
  var suppressClicksUntil = 0;
  var lastPreviewSrc = '';
  var lastPreviewLabel = null;
  var overlay = null;
  var bubble = null;
  var img = null;

  function ensureOverlay(){
    if (overlay) return;
    overlay = document.createElement('div');
    overlay.className = 'es-swatch-preview-overlay';
    overlay.setAttribute('aria-hidden', 'true');
    overlay.innerHTML = '<div class="es-swatch-preview-bubble"><img class="es-swatch-preview-img" alt="" draggable="false" /></div>';
    document.body.appendChild(overlay);
    bubble = overlay.querySelector('.es-swatch-preview-bubble');
    img = overlay.querySelector('img');
  }

  function extractBgUrl(el){
    try{
      var bg = window.getComputedStyle(el).backgroundImage || '';
      // url("...") or url('...') or url(...)
      var m = bg.match(/url\((['\"]?)(.*?)\1\)/i);
      return m ? (m[2] || '') : '';
    }catch(e){
      return '';
    }
  }

  function upscaleShopifyUrl(url){
    if (!url) return '';
    var u = url;

    // Replace common size suffix like _360x or _200x before extension
    u = u.replace(/_(\d{1,4})x(?=\.(?:png|jpe?g|webp|gif)|\?)/ig, '_900x');

    // Try adding width=900 (Shopify CDN supports this on most themes)
    try{
      var protoUrl = u.indexOf('//') === 0 ? ('https:' + u) : u;
      var parsed = new URL(protoUrl, window.location.href);
      parsed.searchParams.set('width', '900');
      u = parsed.toString();
      if (url.indexOf('//') === 0) u = u.replace(/^https?:/, '');
    }catch(e){
      // ignore
    }

    return u;
  }

  function getLabelFromNode(node){
    if (!node) return null;
    try{
      if (node.matches && node.matches(SWATCH_IMG_SELECTOR)) return node;
    }catch(e){}
    try{
      return node.closest ? node.closest(SWATCH_IMG_SELECTOR) : null;
    }catch(e){
      return null;
    }
  }

  // Given any node inside a swatch item (including the text label),
  // return the inner label element that actually has the background-image.
  function getPressLabelFromNode(node){
    if (!node) return null;
    try{
      var item = node.closest ? node.closest(SWATCH_PRESS_SELECTOR) : null;
      if (item){
        var inner = item.querySelector ? item.querySelector(SWATCH_LABEL_IN_ITEM) : null;
        if (inner) return inner;
      }
    }catch(e){}
    return getLabelFromNode(node);
  }

  function getLabelAtPoint(x, y){
    try{
      return getPressLabelFromNode(document.elementFromPoint(x, y));
    }catch(e){
      return null;
    }
  }

  function positionBubble(clientX, clientY){
    var vw = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    var vh = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);

    var size = Math.min(vw * 0.84, 360);
    bubble.style.width = size + 'px';
    bubble.style.height = size + 'px';

    var top = clientY - size - 22;
    top = Math.min(Math.max(top, 84), vh - size - 28);

    var left = clientX - (size / 2);
    left = Math.min(Math.max(left, 16), vw - size - 16);

    bubble.style.transform = 'translate3d(' + Math.round(left) + 'px,' + Math.round(top) + 'px,0)';
  }

  function setPreview(labelEl, clientX, clientY, firstShow){
    ensureOverlay();
    if (!labelEl) return;

    var raw = extractBgUrl(labelEl);
    if (!raw) return;

    var big = upscaleShopifyUrl(raw);
    if (big && big !== lastPreviewSrc){
      img.src = big;
      lastPreviewSrc = big;
    }
    img.alt = 'Swatch preview';

    positionBubble(clientX, clientY);

    if (firstShow){
      overlay.style.display = 'block';
      void overlay.offsetHeight;
      overlay.classList.add('is-visible');
      overlay.setAttribute('aria-hidden', 'false');
      previewShown = true;
      previewMode = true;
    }
  }

  function showPreview(el, clientX, clientY){
    setPreview(el, clientX, clientY, true);
    lastPreviewLabel = el;
  }

  function hidePreview(){
    if (!overlay) return;
    overlay.classList.remove('is-visible');
    overlay.setAttribute('aria-hidden', 'true');
    window.setTimeout(function(){
      if (overlay) overlay.style.display = 'none';
    }, 140);
    previewShown = false;
  }

  function clearTimer(){
    if (pressTimer){
      window.clearTimeout(pressTimer);
      pressTimer = null;
    }
  }

  function endPress(){
    clearTimer();
    if (previewShown) hidePreview();
    // Suppress the click that can fire after long-press ends (so we don't select)
    if (previewMode){
      suppressClicksUntil = Date.now() + 500;
    }

    previewMode = false;
    pressTarget = null;
    lastPreviewLabel = null;
  }

  function initPointerEvents(){
    document.addEventListener('pointerdown', function(e){
      if (!isPDP() || !isMobile()) return;
      // Accept presses anywhere inside the swatch item (image OR text)
      var node = e.target;
      var item = node && node.closest ? node.closest(SWATCH_PRESS_SELECTOR) : null;
      var target = null;
      try{
        if (item) target = item.querySelector(SWATCH_LABEL_IN_ITEM);
      }catch(err){}
      if (!target){
        target = node && node.closest ? node.closest(SWATCH_IMG_SELECTOR) : null;
      }
      if (!target) return;

      // Don't run inside quickview or popups
      if ((item || target).closest && (item || target).closest('.quickview-product, .br-product-popup, #popup-quickview, #quick-view')) return;

      // Only touch/pen (avoid desktop mouse)
      if (e.pointerType && e.pointerType === 'mouse') return;

      pressTarget = target;
      startX = e.clientX;
      startY = e.clientY;
      previewShown = false;
      previewMode = false;
      lastPreviewLabel = target;

      clearTimer();
      pressTimer = window.setTimeout(function(){
        if (!pressTarget) return;
        showPreview(pressTarget, startX, startY);
      }, 260);
    }, {passive:true, capture:true});

    document.addEventListener('pointermove', function(e){
      if (!pressTarget) return;

      if (!previewShown){
        var dx = Math.abs(e.clientX - startX);
        var dy = Math.abs(e.clientY - startY);
        if ((dx + dy) > 12){
          // Finger moved too far before the long-press triggered — treat it as scroll/drag.
          clearTimer();
          pressTarget = null;
        }
        return;
      }

      // Preview is visible: allow sliding across other swatches to preview quickly.
      var lbl = getLabelAtPoint(e.clientX, e.clientY);
      if (lbl) lastPreviewLabel = lbl;
      var cur = lastPreviewLabel || pressTarget;
      if (cur){
        pressTarget = cur;
        setPreview(cur, e.clientX, e.clientY, false);
      }
    }, {passive:true, capture:true});

    document.addEventListener('pointerup', endPress, {passive:true, capture:true});
    document.addEventListener('pointercancel', endPress, {passive:true, capture:true});

    window.addEventListener('scroll', function(){
      if (previewShown) hidePreview();
    }, {passive:true});
  }

  function initTouchFallback(){
    document.addEventListener('touchstart', function(e){
      if (!isPDP() || !isMobile()) return;
      // Accept presses anywhere inside the swatch item (image OR text)
      var node = e.target;
      var item = node && node.closest ? node.closest(SWATCH_PRESS_SELECTOR) : null;
      var t = null;
      try{
        if (item) t = item.querySelector(SWATCH_LABEL_IN_ITEM);
      }catch(err){}
      if (!t){
        t = node && node.closest ? node.closest(SWATCH_IMG_SELECTOR) : null;
      }
      if (!t) return;
      if ((item || t).closest && (item || t).closest('.quickview-product, .br-product-popup, #popup-quickview, #quick-view')) return;

      var touch = e.touches && e.touches[0];
      if (!touch) return;

      pressTarget = t;
      startX = touch.clientX;
      startY = touch.clientY;
      previewShown = false;
      previewMode = false;
      lastPreviewLabel = t;

      clearTimer();
      pressTimer = window.setTimeout(function(){
        if (!pressTarget) return;
        showPreview(pressTarget, startX, startY);
      }, 260);
    }, {passive:true, capture:true});

    document.addEventListener('touchmove', function(e){
      if (!pressTarget) return;
      var touch = e.touches && e.touches[0];
      if (!touch) return;

      if (!previewShown){
        var dx = Math.abs(touch.clientX - startX);
        var dy = Math.abs(touch.clientY - startY);
        if ((dx + dy) > 12){
          clearTimer();
          pressTarget = null;
        }
        return;
      }

      // Keep the page from scrolling while the user is scrubbing swatches.
      try{ e.preventDefault(); }catch(err){}

      var lbl = getLabelAtPoint(touch.clientX, touch.clientY);
      if (lbl) lastPreviewLabel = lbl;
      var cur = lastPreviewLabel || pressTarget;
      if (cur){
        pressTarget = cur;
        setPreview(cur, touch.clientX, touch.clientY, false);
      }
    }, {passive:false, capture:true});

    document.addEventListener('touchend', endPress, {passive:true, capture:true});
    document.addEventListener('touchcancel', endPress, {passive:true, capture:true});

    window.addEventListener('scroll', function(){
      if (previewShown) hidePreview();
    }, {passive:true});
  }

  // Show a tiny usage hint once on mobile (does not take permanent space)
  function showHoldHintOnce(){
    // Mobile-only micro hint: show ONLY when the swatch section becomes visible.
    // This avoids "using up" the 2s hint while the user is still at the top of a long PDP.
    if (!isPDP() || !isMobile()) return;

    var tip = document.querySelector('.es-swatch-tip');
    if (!tip) return;

    // Versioned key so we can iterate safely
    var key = 'es_swatch_hold_preview_hint_v2';
    try{
      if (window.localStorage && localStorage.getItem(key) === '1') return;
    }catch(e){}

    var target = document.querySelector('.es-swatch-strip') || (tip.parentElement ? tip.parentElement : tip);

    function markSeen(){
      try{
        if (window.localStorage) localStorage.setItem(key, '1');
      }catch(e){}
    }

    function play(){
      markSeen();

      // Make it visible briefly, then hide again (low-profile)
      tip.style.display = 'inline';
      tip.classList.remove('is-visible');

      // Small delay to avoid flashing during layout shifts
      window.setTimeout(function(){
        try{ tip.classList.add('is-visible'); }catch(e){}

        window.setTimeout(function(){
          try{ tip.classList.remove('is-visible'); }catch(e){}
          window.setTimeout(function(){
            try{ tip.style.display = 'none'; }catch(e){}
          }, 220);
        }, 2000);
      }, 150);
    }

    function isInView(el){
      if (!el || !el.getBoundingClientRect) return true;
      var r = el.getBoundingClientRect();
      var vh = (window.innerHeight || document.documentElement.clientHeight);
      return (r.bottom > 0 && r.top < vh);
    }

    // If user landed near the swatches already, show immediately
    if (isInView(target)){
      play();
      return;
    }

    // Prefer IntersectionObserver for accuracy + performance
    if ('IntersectionObserver' in window){
      var io = new IntersectionObserver(function(entries){
        for (var i = 0; i < entries.length; i++){
          if (entries[i].isIntersecting){
            try{ io.disconnect(); }catch(e){}
            play();
            break;
          }
        }
      }, {threshold: 0.15});

      try{
        io.observe(target);
      }catch(e){
        play();
      }
    }else{
      // Fallback: show on first scroll when swatches enter view
      var onScroll = function(){
        if (isInView(target)){
          window.removeEventListener('scroll', onScroll);
          play();
        }
      };
      window.addEventListener('scroll', onScroll, {passive:true});
    }
  }


  function boot(){
    if (!isPDP()) return;
    if (!isMobile()){
      // still allow on rotation: initialize anyway; handlers gate by isMobile()
    }

    // Prevent iOS/Android long-press context menu on swatches (would block the preview)
    document.addEventListener('contextmenu', function(e){
      if (!isPDP() || !isMobile()) return;
      var node = e.target;
      var t = null;
      try{
        if (node && node.closest) t = node.closest(SWATCH_PRESS_SELECTOR) || node.closest(SWATCH_IMG_SELECTOR);
      }catch(err){}
      if (!t) return;
      e.preventDefault();
    }, {capture:true});

    // Suppress the click that can fire after a long-press preview ends.
    // This keeps the preview feature from changing the currently selected swatch.
    document.addEventListener('click', function(e){
      if (!isPDP() || !isMobile()) return;
      if (Date.now() > suppressClicksUntil) return;
      var inSwatches = e.target && e.target.closest ? e.target.closest('.es-swatch-strip') : null;
      if (!inSwatches) return;
      try{ e.preventDefault(); }catch(err){}
      try{ e.stopPropagation(); }catch(err){}
    }, true);

    if (window.PointerEvent){
      initPointerEvents();
    }else{
      initTouchFallback();
    }

    // Hint: only once per device
    showHoldHintOnce();
  }

  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', boot);
  }else{
    boot();
  }
})();
